// extracted by mini-css-extract-plugin
export default {"button":"BackspaceButton_button__dCdy4","subtitle":"BackspaceButton_subtitle__R0IFl"};